import { Picker } from "@/components/ui/Picker";
import { X } from "lucide-react";

import type { UserOption } from "./types";

export interface UserPickerSelectViewProps {
  candidates: UserOption[];
  value: UserOption | null;
  addLabel: string;
  searchPlaceholder?: string;
  emptyText?: string;
  isEditable: boolean;
  isLoading: boolean;
  clearLabel?: string;
  onSelect: (userId: string) => void;
}

export const UserPickerSelectView = ({
  candidates,
  value,
  addLabel,
  searchPlaceholder,
  emptyText,
  isEditable,
  isLoading,
  clearLabel,
  onSelect,
}: UserPickerSelectViewProps) => {
  const items = candidates.map((user) => ({ value: user.user_id, label: user.name }));

  return (
    <div className="flex items-center gap-1">
      <Picker
        items={items}
        value={value?.user_id ?? null}
        displayLabel={value?.name ?? null}
        onChange={onSelect}
        sortItems
        placeholder={addLabel}
        searchPlaceholder={searchPlaceholder}
        commandEmptyLabel={emptyText}
        isLoading={isLoading}
        disabled={!isEditable}
        triggerVariant="ghost"
        /** Ghost triggers are `w-fit`, so the popover can't inherit the trigger width. */
        contentClassName="w-64"
        popoverModal
      />
      {clearLabel && value !== null && isEditable && (
        <button
          type="button"
          aria-label={clearLabel}
          className="flex items-center text-text-disabled hover:text-muted-foreground"
          onClick={(e) => {
            e.stopPropagation();
            onSelect("");
          }}
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </div>
  );
};
